/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol extends models.ServiceAccountCredentialsBaseForKubernetesClusterGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol>): ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol(), model);
        ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol>): ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol.newInstance(<ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesClusterGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForKubernetesClusterGcpOauthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Project Id in which the bucket exists. This is a required field.
     */
    project_id: string;

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Client Secret. This is a required field.
     */
    client_secret: string;

    /**
     * Redirect URI. This is a required field.
     */
    redirect_uri: string;

    /**
     * Authorization Code. This is a required field.
     */
    authorization_code: string;

}
